import { MedicalDataTypes } from '../../primary-record-types';

/**
 * Cross-resource-type check to see if a resource is active
 */
export const isResourceActive = (resource: MedicalDataTypes.PrimaryRecordResource) => {
    if (resource.type === 'allergy') {
        return resource.status === 'active' || resource.status === 'chronic';
    } else if (resource.type === 'condition') {
        return resource.status === 'active' || resource.status === 'chronic';
    } else if (resource.type === 'medication') {
        return resource.isActive;
    } else if (resource.type === 'visit') {
        return false;
    }
};
